import * as btc from '@scure/btc-signer';

import { Network } from ':fat/core/networks';
import { Transaction } from ':fat/workers/blockchain/types';

// Since the Transaction object will come over the message bus as a plain
// object, we need to turn it back into a Transaction of the correct class.
export function reconstructTransactions(txs: Record<Network, Transaction[]>) {
  for (const [n, networkTxs] of Object.entries(txs)) {
    const network = n as Network;
    for (const txData of networkTxs) {
      if (network !== 'eth') {
        Object.setPrototypeOf(txData, Object.getPrototypeOf(new btc.Transaction()) as object);
      }
    }
  }

  return txs;
}
